/**
 * @generated SignedSource<<f27e7443d050ab4137264e6846e36fe6>>
 * @relayHash 340d4f5f070919a0755dcf2816c6e362
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type JiraUpdateVersionArchivedStatusInput = {
  id: string;
  isArchived: boolean;
};
export type versionStatus_updateVersionArchivedMutation$variables = {
  input: JiraUpdateVersionArchivedStatusInput;
};
export type versionStatus_updateVersionArchivedMutation$data = {
  readonly jira: {
    readonly updateVersionArchivedStatus: {
      readonly success: boolean;
      readonly version: {
        readonly canAddAndRemoveIssues: boolean | null | undefined;
        readonly canEditRelatedWork: boolean | null | undefined;
        readonly status: JiraVersionStatus | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type versionStatus_updateVersionArchivedMutation = {
  response: versionStatus_updateVersionArchivedMutation$data;
  variables: versionStatus_updateVersionArchivedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "status"
},
v4 = {
  "kind": "ScalarField",
  "name": "canAddAndRemoveIssues"
},
v5 = {
  "kind": "ScalarField",
  "name": "canEditRelatedWork"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "versionStatus_updateVersionArchivedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionArchivedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "versionStatus_updateVersionArchivedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionArchivedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49",
    "metadata": {},
    "name": "versionStatus_updateVersionArchivedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3e4bee8708d54a5a32d8530c63b327c7";

export default node;
